<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="ded"><span aria-label="page v" id="page_v" role="doc-pagebreak">For my sisters, Rosi Reed and Kati Bartkowski, who filled my childhood with endless story inspiration. I don’t know who I would be without both of you in my life.</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f90d8abe